export default {
  Menu: {
    Inicio: 'Inicio',
    Estado: 'Estado',
    Experiencias: 'Experiencias',
    PorQueRegistrarse: 'Porqué Registrarse',
    Asesoria: 'Asesoría y Curaduría',
    EnviosYDevoluciones: 'Envíos y Devoluciones',
    Faq: 'Preguntas Frecuentes',
    TarjetaRegalo: 'Tarjeta Regalo',
    Alianzas: 'Alianzas',
    Contactanos: 'Contáctanos',
    QuienesSomos: 'Quiénes Somos',
    TrabajaConNosotros: 'Trabaja Con Nosotros',
    PoliticaDePrivacidad: 'Política de Privacidad',
    Disenadores: 'Diseñadores',
    Artistas: 'Artistas',
    Magazine: 'Magazine',
    Perfil: 'Perfil',
    Carrito: 'Cesta de Compras',
    Error404: 'Error 404',
    Acceso: 'Iniciar Sesión',
    CerrarMenu: 'Cerrar Menú',
    CerrarSesion: 'Cerrar Sesión',
    Administracion: 'Administración',
    Oficina: 'Back Office',
    ProductosOficina: 'Productos',
    CapacitacionOficina: 'Capacitación',
    VentasOficina: 'Ventas',
    SoporteOficina: 'Soporte',
    Postulate: 'Preséntate',
    Club: 'Club',
    Eventos: 'Eventos',
    Usuario: 'Usuario',
    Articulo: 'Artículo',
    Empresas: 'Empresas',
    ConfirmarNewsletter: 'Confirmar Newsletter',
    Producto: 'Producto',
    PorQueComprar: 'Por Qué Comprar',
    Regalo: 'Tarjeta Regalo',
    Tours: 'Tours Artísticos',
    TyC: 'Términos y Condiciones',
    Confirmación: 'Confirmación',
    GeneralPerfil: 'General',
    FavoritosPerfil: 'Favoritos',
    PedidosPerfil: 'Pedidos',
    AdministracionGeneral: 'General',
    AdministracionAplicaciones: 'Aplicaciones',
    AdministracionMagazine: 'Magazine',
    AdministracionPaginas: 'Páginas',
    AdministracionProductos: 'Productos',
    AdministracionUsuarios: 'Usuarios',
    AdministracionExperiencias: 'Experiencias',
    AdministracionManual: 'Capacitación',
    AdministracionContratos: 'Contratos',
    AdministracionCertificados: 'Certificados',
    AdministracionPedidos: 'Pedidos',
    AdministracionPagos: 'Pagos',
    AdministracionEntregaDinero: 'Entrega Dinero',
    AdministracionNewsletter: 'Newsletter',
    AdministracionCupones: 'Cupones',
    CreativeCommons: 'Creative Commons',
    CompraSegura: 'Compra segura',
    CertificadoAutenticidad: 'Certificado de Autenticidad',
    EntregasInternacionales: 'Entregas Internacionales',
    DíasDevoluciones: '5 días para devoluciones',
    NecesitasAyuda: '¿Necesitas Ayuda?',
    ContactoTrArtist: '¿Quieres hablar con alguien en TrArtist?',
    BiografiaObras: 'Ir a Biografía y Obras',
    Biografia: 'BIOGRAFÍA',
    ReferenciaPersonal: 'Referencia personal',
    ReferenciaProfesional: 'Referencia profesional',
    SubscripcionSletter: 'Suscríbete a nuestro Newsletter'
  },
  Alias: {
    Inicio: '/',
    Estado: '/estado',
    PorQueRegistrarse: '/porqueregistrarse',
    Asesoria: '/asesoria',
    EnviosYDevoluciones: '/envios',
    Faq: '/faq',
    TarjetaRegalo: '/tarjetaregalo',
    Alianzas: '/alianzas',
    Contactanos: '/contactanos',
    QuienesSomos: '/quienessomos',
    TrabajaConNosotros: '/trabajaconnosotros',
    PoliticaDePrivacidad: '/privacidad',
    Disenadores: '/disenadores',
    Artistas: '/artistas',
    Magazine: '/magazine',
    Perfil: '/perfil',
    Carrito: '/carrito',
    Acceso: '/acceso',
    Administracion: '/administracion',
    Oficina: '/backoffice',
    ProductosOficina: '/backoffice/productos',
    CapacitacionOficina: '/backoffice/capacitacion',
    VentasOficina: '/backoffice/ventas',
    SoporteOficina: '/backoffice/soporte',
    Postulate: '/presentate',
    Eventos: '/eventos',
    Club: '/club',
    Articulo: '/articulo',
    Empresas: '/empresas',
    ConfirmarNewsletter: '/confirmarnewsletter',
    Usuario: '/u',
    PorQueComprar: '/porquecomprar',
    Regalo: '/tarjetaregalo',
    Tours: '/tours',
    TyC: '/tyc',
    Confirmacion: '/confirmacion',
    GeneralPerfil: '/perfil/general',
    FavoritosPerfil: '/perfil/favoritos',
    PedidosPerfil: '/perfil/pedidos',
    AdministracionGeneral: '/administracion/general',
    AdministracionAplicaciones: '/administracion/aplicaciones',
    AdministracionMagazine: '/administracion/magazine',
    AdministracionPaginas: '/administracion/paginas',
    AdministracionProductos: '/administracion/productos',
    AdministracionUsuarios: '/administracion/usuarios',
    AdministracionExperiencias: '/administracion/experiencias',
    AdministracionManual: '/administracion/capacitacion',
    AdministracionContratos: '/administracion/contratos',
    AdministracionCertificados: '/administracion/certificados',
    AdministracionPedidos: '/administracion/pedidos',
    AdministracionPagos: '/administracion/pagos',
    AdministracionNewsletter: '/administracion/newsletter',
    AdministracionCupones: '/administracion/cupones',
    // new
    CreativeCommons: '/creativecommons'
  },
  SubMenus: {
    ParaCompradores: 'Para compradores',
    ParaArtistas: 'Para artistas y diseñadores',
    AcercaDe: 'Acerca de Nosotros',
    Trartist: 'TrArtist',
    Idioma: 'Idioma',
    Moneda: 'Moneda',
    Productos: 'Productos',
    Ventas: 'Ventas',
    Capacitacion: 'Capacitación',
    Soporte: 'Soporte'
  },
  Formularios: {
    Encargo: 'Producto bajo pedido',
    EncargoDias: 'Producto bajo pedido. Tiempo de entrega (días)',
    Vision: '¿Qué visión tienes como artista y/o diseñador en 5-10 y 15 años?',
    Camino: 'Según tu forma de entender el arte y/o el diseño ¿Cuál sería el camino para llegar a tener una mayor cultura artística global?',
    VerMas: 'Ver Más',
    Salir: 'Salir',
    VerificarColor: '*Te sugerimos verificar los colores en varios dispositivos, ya que pueden variar.',
    MedidasProducto: 'Medidas del Producto',
    MedidasEmpacado: 'Medidas del producto Empacado',
    MedidasComoEmpacar: '¿Cómo quieres que empaquemos tu obra de arte?',
    ObraBastidor: 'Obra en el bastidor',
    ObraEnrollada: 'Obra enrollada',
    MensajeEnrollado: '*Este empaquetado podría reducir el costo del envío',
    PrecioCOL: 'Precio en pesos Colombianos',
    PrecioUSD: 'Precio en dolares Estadounidenses (USD)',
    MiProductoIVA: 'Mi producto factura IVA',
    ValorNeto: 'Valor a recibir NETO',
    ValorNetoUSD: 'Valor a recibir NETO en USD',
    ComisionTrArtist: '35% Comisión TrArtist',
    ComisionTrArtistUSD: '35% Comisión TrArtist en USD',
    PrecioSinIva: 'Precio Venta Sin IVA',
    PrecioSinIvaUSD: 'Precio Venta Sin IVA en USD',
    IvaNeto: 'IVA 19% Neto',
    IvaNetoUSD: 'IVA 19% Neto en USD',
    PrecioPublicoCOL: 'Precio de Venta al Público COL',
    PrecioPublicoUSD: 'Precio de Venta al Público USD',
    VendedorRecibira: 'El vendedor recibirá NETO más IVA',
    VendedorRecibiraUSD: 'El vendedor recibirá NETO más IVA en USD',
    IvaVendedor: 'IVA que recibirá el vendedor',
    IvaVendedorUSD: 'IVA que recibirá el vendedor en USD',
    NuevoCupon: 'Se te generará un cupón nuevo con el dinero restante',
    Cupon: 'Cupón',
    GuardarSinEnviar: 'Guardar Sin Enviar',
    EnviarAprobacion: 'Enviar para Aprobación',
    EliminarPerfil: 'Eliminar Perfil Permanentemente',
    TituloEliminar: 'Eliminar mi Perfil',
    MensajeEliminar: 'Esta acción es permanente y se borrará toda la información relacionada contigo, piénsalo dos veces porque no podrás recuperar la información',
    PruebaEnvio: 'Sube una foto del paquete enviado',
    Etiquetas: 'Etiquetas (Presiona Tab o Enter para la siguiente)',
    Etiqueta: 'Etiquetas',
    CampoRequerido: 'Campo Requerido',
    Hora: 'Hora',
    Del: 'Del',
    Al: 'Al',
    IrEnlace: 'Ir al enlace',
    Certificado: 'Certificado de Autenticidad',
    Transportadora: 'Transportadora',
    Por: 'Por',
    DireccionEntrega: 'Dirección de Entrega',
    Comprador: 'Comprador',
    EscogerTalla: 'Debes escoger una Talla',
    EscogerColor: 'Debes escoger un Color',
    SeleccionaColor: 'Selecciona si tu producto contiene colores o tallas',
    SeleccionaTipoMoneda: 'Selecciona el tipo de moneda para tu producto',
    PrecioDiaVenta: '* El dinero que recibirás será el correspondiente  a la tasa de cambio del día que se realice la venta, según el monto que haya recibido TrArtist',
    AgregaColor: 'Agrega primero los colores y/o tallas disponibles, luego finaliza colocando el inventario disponible para cada uno',
    Tipo: 'Tipo',
    RevisarPedido: 'Revisar Pedido',
    DescargarProducto: 'Descargar Producto',
    AdvertenciaImagenes: 'Sube máximo 2 imágenes',
    Video: 'Link Video',
    Plataforma: 'Plataforma Video',
    ProductoEnviado: 'El Producto se ha enviado',
    ProductoEmpacando: 'El Producto se está empacando',
    MarcarEnviado: 'Marcar como Enviado',
    Guia: 'Número de Guía',
    Enviado: 'Enviado',
    Desuscribirse: 'No recibir más correos de TrArtist',
    Ver: 'Ver',
    VerContrato: 'Ver Contrato',
    ContratoAprobado: 'Tu Contrato Ha Sido Aprobado',
    ContratoSubido: 'Tu Contrato se encuentra en revisión',
    Aprobado: 'Aprobado',
    Rechazado: 'Rechazado',
    Pendiente: 'Pendiente',
    NoAprobado: 'No Aprobado',
    HintNoAprobado: 'Completa toda la información de tu perfil y firma el contrato para que se apruebe tu cuenta',
    EnRevision: 'Tu perfil se encuentra en revisión',
    Secciones: 'Secciones',
    NombreRequerido: 'Nombre Requerido',
    PseudonimoRequerido: 'Pseudónimo Requerido',
    EmailRequerido: 'Email Requerido',
    EmailValido: 'No es un Email válido',
    ContrasenaRequerido: 'Contraseña Requerida',
    ContrasenaTamano: 'La contraseña debe tener 6 o más caracteres',
    TelefonoRequerido: 'Teléfono Requerido',
    PaisRequerido: 'País Requerido',
    DepartamentoRequerido: 'Departamento Requerido',
    CiudadRequerido: 'Ciudad Requerida',
    CategoriaRequerido: 'Categoría Requerido',
    BiografiaRequerido: 'Biografía Requerido',
    ComentarioDelModerador: 'Comentario Del Moderador',
    Dimensiones: 'Dimensiones',
    DimensionesEmpacado: 'Dimensiones Empacado',
    DimensionesEnrollado: 'Dimensiones enrollado',
    Estado: 'Estado',
    Producto: 'Producto',
    RevisarProducto: 'Revisar Producto',
    Autor: 'Autor',
    DescripcionEs: 'Descripción (Español)',
    DescripcionEn: 'Descripción (Ingles)',
    NuevaSeccion: 'Nueva Sección',
    EditarSeccion: 'Editar Sección',
    Imagen: 'Imagen',
    NuevoMiembro: 'Nuevo Miembro',
    EditarMiembro: 'Editar Miembro',
    AbajoIzquierda: 'Abajo Izquierda',
    AbajoDerecha: 'Abajo Derecha',
    Centro: 'Centro',
    ArribaIzquierda: 'Arriba Izquierda',
    ArribaDerecha: 'Arriba Derecha',
    MarcaDeAgua: 'Marca de Agua',
    DescargarContrato: 'Descargar Contrato',
    SubirContrato: 'Subir Contrato',
    ArtistaODisenador: 'Artista o Diseñador',
    Registro: 'Registro',
    VerArticulo: 'Ver Artículo',
    VerPagina: 'Ver Página',
    Visitas: 'Visitas',
    TituloEs: 'Titulo en Español',
    TituloEn: 'Titulo en Inglés',
    Guardar: 'Guardar',
    CargandoImagen: 'Cargando Imagen, espera un momento',
    NombreCompleto: 'Nombre Completo',
    ResumenEs: 'Resumen en Español',
    ResumenEn: 'Resumen en Inglés',
    ContenidoEs: 'Contenido en Español',
    ContenidoEn: 'Contenido en Inglés',
    Estilo: 'Estilo',
    EstiloEn: 'Estilo en Ingles',
    Formato: 'Formato',
    Orientacion: 'Orientación',
    OrientacionEn: 'Orientación en Ingles',
    Exponer: 'Exponer sin Vender',
    Exhibicion: 'Producto en Exhibición',
    Referencia: 'Referencia',
    Suscribirme: 'Suscribirme',
    NuevoProducto: 'Nuevo Producto',
    EditarProducto: 'Editar Producto',
    Categoria: 'Categoría',
    CategoriaEn: 'Categoría en Ingles',
    Disenador: 'Diseñador',
    Email: 'Correo Electrónico',
    Nombre: 'Nombre Completo',
    Pseudonimo: 'Pseudonimo o Marca',
    Telefono: 'Teléfono',
    TelefonoIndicativo: 'Teléfono móvil con indicativo del país',
    Pais: 'País',
    Departamento: 'Departamento',
    Ciudad: 'Ciudad',
    Biografia: 'Biografía y Exposiciones',
    BiografiaEs: 'Biografía y Exposiciones en Español',
    BiografiaEn: 'Biografía y Exposiciones en Inglés',
    RedSocial: 'Red Social',
    EnlaceRedSocial: 'Enlace',
    AnadirRedSocial: 'Añadir Red Social',
    IncluirRedSocial: 'Incluir Red Social',
    Red: 'Red',
    Enlace: 'Enlace',
    Acciones: 'Acciones',
    FinalizarInscripcion: 'Finalizar Inscripción',
    Contrasena: 'Contraseña',
    FinalizarRegistro: 'Finalizar Registro',
    IniciarSesion: 'Iniciar Sesión',
    Newsletter: 'Quiero recibir información, invitaciones y novedades de TrArtist',
    Soy: 'Soy',
    Cliente: 'Cliente',
    Artista: 'Artista',
    Acceso: 'Iniciar Sesión',
    Codigo: 'Código',
    ComprobarCodigo: 'Comprobar Código',
    Postulate: 'Preséntate',
    AunNoTienesCodigo: 'Aún no tienes tu código de aprobación?',
    TipoDeDocumento: 'Tipo de Documento',
    DocumentoIdentificacion: 'Documento de Identificación',
    AdjuntarDocumento: 'Adjuntar Documento de Identidad',
    Direccion: 'Dirección',
    VideoYoutube: 'Link Video Youtube',
    FotoPerfil: 'Foto de Perfil',
    Paypal: 'Paypal',
    CuentaDePaypal: 'Cuenta de Paypal',
    ConsignacionBancaria: 'Consignación Bancaria',
    AdjuntarCertificacion: 'Adjuntar Certificación Bancaria',
    CedulaCiudadania: 'Cédula de Ciudadanía',
    TarjetaIdentidad: 'Tarjeta de Identidad',
    CedulaExtranjeria: 'Cédula de Extranjería',
    Acepto: 'Acepto',
    NoAcepto: 'No Acepto',
    TyC: 'Acepto los términos y condiciones de TrArtist.com',
    AdjuntaImagenes: 'Adjunta 3 imágenes de tu trabajo',
    Imagenes: 'Imágenes',
    Titulo: 'Titulo',
    Resumen: 'Resumen',
    Descripcion: 'Descripción',
    EnlacePermanente: 'Enlace Permanente',
    EnlaceHint: 'trartist.com/articulo/enlace (Sin Espacios, Solo guiones)',
    Publicar: 'Publicar',
    Actualizar: 'Actualizar',
    Usuario: 'Nombre de Usuario',
    HintUsuario: 'trartist.com/u/usuario (Sin espacios, solo letras)',
    NuevaFoto: 'Nueva Foto',
    Eliminar: 'Eliminar',
    VerPerfil: 'Ver Mi Perfil',
    Cerrar: 'Cerrar',
    Editar: 'Editar',
    NuevoArticulo: 'Nuevo Artículo',
    EditarArticulo: 'Editar Artículo',
    Precio: 'Precio',
    PrecioUnitario: 'Precio Unitario',
    PrecioTotal: 'Precio Total',
    PrecioFinalCOP: 'Precio Final COP',
    PrecioFinalUSD: 'Precio Final USD',
    Cantidad: 'Cantidad',
    ImagenPrincipal: 'Imagen Principal',
    ImagenSecundaria: 'Imagen Secundaria',
    ImagenesApoyo: 'Vistas del Producto',
    Largo: 'Largo (cm)',
    Ancho: 'Ancho (cm)',
    Alto: 'Alto (cm)',
    Peso: 'Peso (gramos)',
    Enrollado: '',
    IncluirEnrollado: 'Incluir empaque enrollado',
    MedidasEmpacadoEnrollado: 'Medidas del Producto Empacado (Enrollado)',
    Digital: 'Producto Digital',
    Fisico: 'Producto Fisico',
    ArchivoDigital: 'Archivo Digital (Un solo Archivo .zip)',
    Mes: 'Mes',
    ZonaFisico: 'Edición Producto Físico',
    ZonaDigital: 'Edición Producto Digital',
    PrecioFisico: 'Precio Físico',
    CantidadFisico: 'Cantidad Físico',
    PrecioDigital: 'Precio Digital',
    CantidadDigital: 'Cantidad Digital',
    Ilimitado: 'Ilimitado',
    MeGusta: 'Me Gusta',
    TextoEliminar: 'Esta acción es permanente y una vez realizado toda tu información será eliminada del sistema.',
    OlvidasteContrasena: 'Olvidaste tu Contraseña?',
    Parrafo1: 'Párrafo 1',
    Parrafo2: 'Párrafo 2',
    Parrafo3: 'Párrafo 3',
    Subtitulo: 'Subtítulo',
    ImagenParrafo: 'Imagen Párrafo',
    UsuarioSinProducto: 'Este Artista no ha publicado productos, aún',
    CodigoPostal: 'Código Postal',
    Cuidados: 'Cuidados',
    CuidadosEs: 'Cuidados (Español)',
    CuidadosEn: 'Cuidados (Ingles)',
    Materiales: 'Materiales',
    MaterialesEs: 'Materiales (Español)',
    MaterialesEn: 'Materiales (Ingles)',
    Tecnica: 'Técnica',
    TecnicaEs: 'Técnica (Español)',
    TecnicaEn: 'Técnica (Ingles)',
    Talla: 'Talla',
    AnadirTalla: 'Añadir Talla',
    TablaTallas: 'Tabla de Tallas',
    Color: 'Color',
    ColorEs: 'Color en Español',
    ColorEn: 'Color en Ingles',
    EsRegalo: 'Es un regalo o desea enviar  este producto a otra dirección',
    DireccionRegalo: 'Dirección Regalo',
    DireccionComprador: 'Dirección Comprador',
    MedioDePago: 'Medio de Pago',
    EnQueEresExperto: '¿En que eres experto? ¿En qué te destacas?, ¿Qué amas hacer?',
    ComoTrabajar: '¿Cómo podemos trabajar juntos?',
    Empresa: 'Empresa',
    CualEsTuPropuesta: '¿Cuál es tu propuesta?',
    EnviarInformacion: 'Enviar Información',
    ComoPodemosAyudarte: '¿Cómo podemos ayudarte?',
    Pagar: 'Pagar',
    Bienvenido: 'Bienvenido',
    Privacidad: 'Nos tomamos en serio tu privacidad y nunca compartiremos tus datos, puedes cambiar de opinión en cualquier momento',
    TelefonoYWhatsapp: 'Teléfono y WhatsApp',
    AsuntoAlianzas: 'Alianzas #{uid} - {nombre}',
    TextoAlianzas: '<span>ID: {uid}</span><br><br><span>Nombre: {nombre}</span><br><br><span>Empresa: {empresa}</span><br><br><span>Ciudad: {pais} - {departamento} - {ciudad}</span><br><br><span>Telefono: {telefono}</span><br><br><span>Correo: {correo}</span><br><br><span>Descripcion: {descripcion}</span>',
    AsuntoAprobado: 'Tu Producto {titulo} ha sido Aceptado',
    MensajeAprobado: '<span>Hola {nombre},</span><br><br><span>Tu producto {titulo} ha sido aprobado y ya está disponible en <a href="trartist.com/p/{uid}">trartist.com</a></span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoRechazado: 'Tu Producto {titulo} no ha sido aprobado',
    MensajeRechazado: '<span>Hola {nombre},</span><br><br><span>Tu producto {titulo} no ha sido aprobado por el siguiente motivo:</span><br><br><span>{comentario}</span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoAprobadoArtista: 'Tu Perfil ha sido aprobado',
    MensajeAprobadoArtista: '<span>Hola {nombre},</span><br><br><span>Tu perfil ha sido aprobado y ya puedes empezar a vender tus productos siguiendo el proceso y los lineamientos de la capacitación del BackOffice</span><br><span>{comentario}</span><br><br><span>Éxitos, un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoRechazadoArtista: 'Tu Perfil no ha sido aprobado',
    MensajeRechazadoArtista: '<span>Hola {nombre},</span><br><br><span>Tu perfil no ha sido aprobado por el siguiente motivo:</span><br><br><span>{comentario}</span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoAsesoria: 'Asesoría #{uid} - {nombre}',
    AsuntoContacto: 'Contacto #{uid} - {nombre}',
    ActualizacionPerfil: 'Ha actualizado su perfil {nombre}',
    TextoActualizacionPerfil: '<span>Hola Equipo TrArtist,</span><br><br><span>{nombre} hizo modificaciones en su perfil y ya puedes revisarlo en TrArtist.com</span>',
    TextoAsesoria: '<span>ID: {uid}</span><br><br><span>Nombre: {nombre}</span><br><br><span>Ciudad: {pais} - {departamento} - {ciudad}</span><br><br><span>Telefono: {telefono}</span><br><br><span>Correo: {correo}</span><br><br><span>Descripcion: {descripcion}</span>',
    AsuntoPostulado: 'Hemos recibido tu aplicación',
    MensajePostulado: '<span>Hola {nombre},</span><br><br><span>Hemos recibido tu aplicación para ser miembro de TrArtist y te daremos la respuesta pronto</span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoTrabaja: 'Trabaja con Nosotros #{uid} - {nombre}',
    TextoTrabaja: '<span>ID: {uid}</span><br><br><span>Nombre: {nombre}</span><br><br><span>Ciudad: {pais} - {departamento} - {ciudad}</span><br><br><span>Telefono: {telefono}</span><br><br><span>Correo: {correo}</span><br><br><span>En qué es experto: {descripcion}</span><br><br><span>Cómo Trabajar: {comoTrabajar}</span>',
    AceptarCreativeC: '¿Desea, agregar la Licencia Creative Commons a este producto? Más info',
    AcogidoCreativeC: '* Obra o diseño con Licencia Creative Commons. Más info',
    MasInformacion: 'Más información:',
    Aqui: 'aquí',
    EnvioIncluido: 'Costo envio incluido',
    ResenaEnglish: ' Reseña en Ingles',
    ResenaSpanish: ' Reseña en Español',
    TipoMoneda: 'Tipo de Moneda',
    CostoEnvio: 'Costo de Envio',
    SubiendoArchivoDigital: 'Subiendo Archivo Digital',
    SubiendoTablaTallas: 'Subiendo Tabla de Tallas',
    ProcesandoImagenPrincipal: 'Procesando Imagen Principal',
    SubiendoImagenesSecundarias: 'Subiendo Imágenes Secundarias',
    SubiendoProducto: 'Subiendo Producto',
    Descargar: 'Descargar'
  },
  Alerta: {
    QuienesSomos: 'En TrArtist los protagonistas son los Artistas y Diseñadores, genios creativos, imaginadores de conversaciones entre sus ideas, su alma y la audiencia, creadores de magia que nos hacen soñar y vibrar, suspirar por tener esa obra de arte, inspirarnos con la música, los libros, un maravilloso video de danza o imaginarnos con una prenda o joya ideal con la que resaltamos toda nuestra belleza y poder, ideas que nos hacen sentir únicos, no uniformados, por que somos millones, y millones son las ideas. Deslumbra al mundo con tu forma de ser, tu estilo y llena tu vida de encanto, tertulias, conversaciones, exploraciones, búsquedas, descubrimientos, eso hacemos en TrArtist”',
    QuienesSomos2: '“Simbiosis de amantes de las artes y el diseño con los creadores de la magia”',
    VerMas: 'Ver más',
    EliminarProducto: 'Estás seguro que deseas eliminar el Producto?',
    ProductoEliminado: 'El producto ha sido eliminado',
    AlIngresar: 'Al ingresar a TrArtist.com aceptas nuestras',
    Entendido: 'Acepto',
    PostulacionExitosa: 'Tu presentación se ha enviado correctamente',
    RegistroExitoso: 'Te has registrado correctamente',
    SesionCerrada: 'Hasta luego, vuelve pronto',
    IniciarSesion: 'Has iniciado sesión correctamente',
    CodigoIncorrecto: 'El código es incorrecto',
    NoAprobado: 'Aún no has sido aprobado.',
    FaltaInformacion: 'Completa la información para continuar',
    NoCoincide: 'El correo electrónico y el código no coinciden',
    Rechazado: 'Tu presentación ha sido rechazada',
    UsuarioActualizado: 'Se ha actualizado tu información de perfil',
    ProductoPublicado: 'Producto publicado correctamente',
    ProductoEnAprobacion: 'Tu Producto se encuentra en aprobación, te notificaremos por correo electrónico cuando haya sido revisado',
    ArticuloPublicado: 'Artículo publicado correctamente',
    NombreEnUso: 'Nombre de Usuario en uso, elige otro',
    SinMeGusta: 'Inicia Sesión para guardar como Favorito',
    InformacionActualizada: 'Información Actualizada Correctamente',
    ImagenCargada: 'Imagen Cargada, Presiona Actualizar para reflejar los cambios en la web',
    ConfirmarEmail: 'Te hemos enviado un email para confirmar tu suscripción',
    EmailRegistrado: 'El Email ya se encuentra registrado',
    ProductoAnadido: 'Producto Añadido Correctamente',
    PerfilEliminado: 'Tu Perfil se ha eliminado correctamente',
    MensajeEnviado: 'Tu Mensaje se ha enviado correctamente',
    ReestablecerContrasena: 'Te hemos enviado un email para reestablecer tu contraseña',
    IntroduceEmail: 'Introduce tu email para recuperar la contraseña',
    Proximamente: 'Próximamente',
    CorreoEnviado: 'El Correo ha sido enviado de forma exitosa',
    EresRobot: 'Nuestro sistema detectó una actividad sospechosa, si eres humano, inténtalo de nuevo.',
    TarjetaVencida: 'Tu Tarjeta se encuentra vencida',
    Copiado: 'Link Copiado, Pégalo en tu red social favorita o envíalo por correo',
    MeGusta: 'Se ha añadido a Favoritos, podrás verlo en tu perfil más tarde',
    NoMeGusta: 'Se ha eliminado el producto de Favoritos',
    ProductoAceptado: 'Producto Aceptado Correctamente',
    ProductoRechazado: 'Producto Rechazado, se han enviado los comentarios al artista',
    InformacionPublicada: 'Información Publicada Correctamente',
    InformacionEliminada: 'Información Eliminada Correctamente',
    AdjuntaImagenes: 'Adjunta Imágenes de tu Trabajo antes de postularte',
    Desuscrito: 'Ya no recibirás más emails de TrArtist',
    GuiaRequerida: 'El número de Guía, Transportadora y Prueba es obligatorio',
    EnvioActualizado: 'El envío se ha actualizado',
    PagoExitoso: 'El pago ha sido exitoso',
    CorreoEnUso: 'El correo ya esta en uso'
  },
  Pago: {
    Selecciona: 'Selecciona tu Método de Pago',
    OtroMedio: 'Elegir Otro Medio de Pago',
    Nombre: 'Nombre Completo',
    Email: 'Correo Electrónico',
    Telefono: 'Teléfono',
    General: 'Información General',
    Pago: 'Pago',
    MedioDePago: 'Medio de Pago',
    Siguiente: 'Siguiente',
    Atras: 'Atrás',
    TipoDocumento: 'Tipo de Documento',
    NumeroDocumento: 'Número de Documento',
    Pagar: 'Pagar',
    Banco: 'Elegir Banco',
    MismaInformacion: 'Llenar con la información de facturación',
    NombreTitular: 'Nombre del Titular',
    TipoDeCliente: 'Tipo de Cliente',
    Confirmacion: 'Confirmación',
    TiposDocumento: {
      CC: '[CC] Cédula de Ciudadanía',
      CE: '[CE] Cédula de Extranjería',
      NIT: '[NIT] Empresa',
      TI: '[TI] Tarjeta de Identidad',
      PP: '[PP] Pasaporte',
      CEL: '[CEL] En caso de identificarse a través de la línea del móvil',
      RC: '[RC] Registro Civil de Nacimiento',
      DE: '[DE] Documento de Identificación Extranjero'
    },
    MediosDePago: {
      Paypal: 'Paypal',
      TarjetaCredito: 'Tarjeta de Crédito',
      TarjetaDebito: 'Tarjeta Débito Visa',
      Pse: 'PSE',
      Efectivo: 'Efectivo o Consignación Bancaria'
    },
    CreditCard: {
      Nombre: 'Nombre del Titular',
      Numero: 'Número de la Tarjeta',
      Fecha: 'Año/Mes',
      CodigoSeguridad: 'CVV'
    },
    TipoCliente: {
      PersonaNatural: 'Persona Natural',
      PersonaJuridica: 'Persona Juridica'
    }
  },
  Categoria: {
    // ARTISTAS
    Pintura: 'Pintura',
    Dibujo: 'Dibujo',
    Ilustracion: 'Ilustración',
    Ilustración: 'Ilustración',
    EsculturaYTalla: 'Escultura y Talla',
    Escultura_Y_Talla: 'Escultura y Talla',
    Fotografia: 'Fotografía',
    Fotografía: 'Fotografía',
    Escritores: 'Escritores',
    Musicos: 'Musicos',
    Danza: 'Danza',
    Murales: 'Murales',
    Impresiones: 'Impresiones',
    Collage: 'Collage',
    Instalaciones: 'Instalaciones',
    Video: 'Video',
    Libro: 'Libro',
    Otros: 'Otros',
    Painting: 'Pintura',
    Draw: 'Dibujo',
    Illustration: 'Ilustración',
    Sculpture_and_Carving: 'Escultura Y Talla',
    Photography: 'Fotografía',
    Writers: 'Escritores',
    Musicians: 'Musicos',
    Dance: 'Danza',
    Murals: 'Murales',
    Prints: 'Impresiones',
    Installations: 'Instalaciones',
    Book: 'Libro',
    Others: 'Otros',
    // DISEÑADORES
    Moda: 'Moda',
    Joyas: 'Joyas',
    Ceramica: 'Cerámica',
    Cerámica: 'Cerámica',
    Artesania: 'Artesanía',
    Mobiliario: 'Mobiliario',
    ObjetosDecoracion: 'Objetos de Decoración',
    Objetos_de_Decoración: 'Objetos de Decoración',
    Invitado: 'Invitado',
    Editorial: 'Editorial TrArtist',
    Stories: 'Stories',
    Todos: 'Todo',
    Fashion: 'Moda',
    Jewelry: 'Joyas',
    Ceramics: 'Ceramica',
    Crafts: 'Artesania',
    Furniture: 'Mobiliario',
    Decoration_objects: 'Objetos de Decoración',
    Invited: 'Invitado',
    TrArtist_Editorial: 'Editorial',
    All: 'Todos',
    // ESTILOS
    Abstracto: 'Abstracto',
    Conceptual: 'Conceptual',
    Figurativo: 'Figurativo',
    Geometrico: 'Geométrico',
    Minimalista: 'Minimalista',
    Moderno: 'Moderno',
    Paisaje: 'Paisaje',
    Animales: 'Animales',
    Fantasia: 'Fantasía',
    Realismo: 'Realismo',
    PopArt: 'Pop Art',
    Retrato: 'Retrato',
    Surrealismo: 'Surrealismo',
    Tipografico: 'Tipográfico',
    Urbano: 'Urbano',
    ArteCallejero: 'Arte Callejero',
    Comic: 'Comic',
    // Orientación
    Cuadrado: 'Cuadrado',
    Todo: 'Todo',
    Fisico: 'Físico',
    Digital: 'Digital',
    // Colores
    NoAplica: 'No Aplica',
    Multicolor: 'Multicolor',
    Amarillo: 'Amarillo',
    Azul: 'Azul',
    Rojo: 'Rojo',
    Verde: 'Verde',
    Negro: 'Negro',
    Blanco: 'Blanco',
    Gris: 'Gris',
    Rosado: 'Rosado',
    Fucsia: 'Fucsia',
    Magenta: 'Magenta',
    Lila: 'Lila',
    Morado: 'Morado',
    Violeta: 'Violeta',
    Naranja: 'Anaranjado o Naranja',
    Plateado: 'Plata o Plateado',
    Dorado: 'Oro o Dorado',
    Cobre: 'Cobre',
    Bronce: 'Bronce',
    Cafe: 'Marrón o Café',
    BlancoNegro: 'Blanco y Negro'
  },
  Mes: {
    Enero: 'Enero',
    Febrero: 'Febrero',
    Marzo: 'Marzo',
    Abril: 'Abril',
    Mayo: 'Mayo',
    Junio: 'Junio',
    Julio: 'Julio',
    Agosto: 'Agosto',
    Septiembre: 'Septiembre',
    Octubre: 'Octubre',
    Noviembre: 'Noviembre',
    Diciembre: 'Diciembre'
  },
  Busqueda: {
    Color: 'Color',
    OrdenarPor: 'Ordenar Por',
    PrecioMenor: 'Menor a Mayor',
    PrecioMayor: 'Mayor a Menor',
    Precio: 'Precio',
    Formato: 'Formato',
    Fisico: 'Físico',
    Digital: 'Digital',
    Ambas: 'Ambas',
    Titulo: 'Título',
    Largo: 'L',
    Ancho: 'An',
    Alto: 'Al',
    Peso: 'P',
    PesoNormal: 'Peso',
    PesoEnrollado: 'Peso enrollado',
    Historial: 'HISTORIAL',
    Disponibles: 'Disponibles',
    UnidadesIlimitadas: 'Unidades Ilimitadas',
    UnidadesDisponibles: 'Unidades Disponibles',
    Vendidos: 'Vendidos',
    Agotado: 'Producto agotado',
    Carrito: 'Añadir a la Cesta',
    PrecioFisico: 'Precio Físico',
    PrecioDigital: 'Precio Digital',
    PaisDeOrigen: 'País de Origen',
    Categoria: 'Categoría',
    Orientacion: 'Orientación',
    Estilo: 'Estilo',
    Buscar: 'Buscar',
    NoAplica: 'No Aplica'
  },
  Club: {
    Club: 'TrArtist Club',
    Subtitulo1: 'Si eres Diseñador o Artista de TrArtist, ya eres parte del Club.',
    Subtitulo2: 'Te agregaremos a nuestro grupo privado de Facebook TrArtist Club, por ese medio nos comunicaremos.',
    Texto1: 'Queremos crear comunidad, construyamos historias que sean fuentes de conocimiento e inspiración, creemos movimientos artísticos y de diseño, apoyémonos, colaborémonos, pensemos e ideemos juntos.',
    Texto2: 'Organizaremos charlas, tertulias, reuniones entre diseñadores y aristas y charlas con interesados (clientes y amantes de las artes y el diseño).'
  },
  Oficina: {
    OtroValor: 'Otro Valor',
    CodigoProducto: 'Código Producto',
    PagosRecibidos: 'Pagos Recibidos',
    CodigoPedido: 'Código Pedido',
    Referencia: 'Referencia',
    FechaVenta: 'Fecha de Venta',
    Producto: 'Producto',
    Fecha: 'Fecha',
    Estado: 'Estado',
    Valor: 'Valor',
    Acciones: 'Acciones',
    SolicitarPago: 'Solicitar Pago',
    Pagos: 'Pagos',
    EnviarSoporte: 'Enviar',
    TipoSolicitud: 'Tipo de Solicitud',
    Descripcion: 'Descripción',
    Nombre: 'Nombre Completo',
    Email: 'Email',
    Asunto: 'Asunto',
    Mensaje: 'Mensaje',
    Enviar: 'Enviar',
    Talla: 'Talla',
    Cantidad: 'Cantidad',
    Tallas: 'Tallas',
    NuevaTalla: 'Agregar Talla',
    EditarTalla: 'Editar Talla',
    Color: 'Color',
    NuevaUnidad: 'Nueva Unidad',
    TallasYColores: 'Tallas y Colores',
    EditarUnidad: 'Editar Unidad',
    Ventas: 'Ventas',
    AnadirTalla: 'Añadir Talla',
    AnadirUnidad: 'Añadir Unidad',
    TituloColor: 'Título Color',
    NuevoColor: 'Agregar Color',
    Colores: 'Colores',
    Inventario: 'Inventario',
    NuevaVariacion: 'Agregar Cantidad',
    ActualizarColor: 'Actualizar Color',
    ActualizarTalla: 'Actualizar Talla',
    ActualizarVariacion: 'Actualizar Inventario',
    InventarioTotal: 'Inventario Total (Solo Lectura)'
  },
  Empresas: {
    Nombre: 'Nombre Completo',
    Email: 'Email',
    Asunto: 'Asunto',
    Mensaje: 'Mensaje',
    Enviar: 'Enviar',
    Pais: 'País'
  },
  Inicio: {
    DescubreArtistas: 'Descubre Artistas',
    DescubreDisenadores: 'Descubre Diseñadores',
    Magazine: 'Magazine',
    VolverMagazine: 'Volver a Magazine',
    LeerArticulo: 'Leer Artículo',
    Favorito: 'Añadir a Mis Favoritos',
    VerProducto: 'Ver Producto',
    Compartir: 'Compartir',
    Equipo: 'Equipo',
    Pwa: 'Añade el App de TrArtist, Espectacular!',
    PwaSafari: 'Añade el App de TrArtist desde Google Chrome, Espectacular!',
    Instalar: 'Instalar',
    DerechosReservados: 'Todos los Derechos Reservados'
  },
  Carrito: {
    Fecha: 'Fecha',
    Horario: 'Horario',
    Pasajeros: 'Pasajeros',
    Preferencias: 'Preferencias',
    MisPedidos: 'Mis Pedidos',
    Aprobado: 'Pago Completado',
    Pendiente: 'Pago Pendiente',
    Rechazado: 'Pago Rechazado',
    MensajePedido: 'Puedes consultar el pedido en tu Perfil',
    Remover: 'Remover',
    Productos: 'Productos',
    Informacion: 'Información',
    Pago: 'Pago',
    CodigoPromocional: 'Código Promocional o Tarjeta Regalo',
    Aplicar: 'Validar Código',
    TiempoDeEnvio: '*El tiempo de envío varía en función del país de origen y destino',
    Continuar: 'Continuar',
    CalcularCosto: 'Calcular costo de envío',
    NoHayProductos: 'No has añadido productos, aún',
    IniciaSesion: 'Inicia Sesión o Regístrate para continuar con la compra',
    Acceso: 'Iniciar Sesión',
    Registro: 'Registro',
    Correo: 'Correo Electrónico',
    Contrasena: 'Contraseña',
    IniciarSesion: 'Iniciar Sesión',
    Registrarse: 'Registrarse',
    CuponUsado: 'El cupón ya ha sido usado',
    Descuento: 'Descuento',
    Resumen: 'Resumen',
    DireccionDeEnvio: 'Dirección de envío',
    Envio: 'Envío',
    SolicitarAsesoria: 'Solicitar Asesoría',
    MediosDePago: 'Medios de Pago',
    TarjetaCredito: 'Tarjeta de Crédito',
    Efectivo: 'Efectivo',
    PagarPaypal: 'Pagar con Paypal',
    RespaldoPayU: 'Con el respaldo de PayU',
    Bancos: 'Pago en Bancos',
    Recuerda: 'Esta es una compra digital, se enviará el archivo en PDF listo para impresión en el tamaño que requieras o MP4 en caso de una tarjeta animada',
    DondeImprimir: 'Dónde Imprimir',
    Valor: 'Valor',
    Descripcion: 'Descripción',
    MedioDePago: 'Medio de Pago',
    ViaBaloto: 'Via Baloto',
    Efecty: 'Efecty',
    SuRed: 'Su Red',
    Sucursal: 'Sucursal',
    Pagar: 'Pagar',
    NombreTarjeta: 'Nombre en la Tarjeta',
    NumeroTarjeta: 'Número de Tarjeta',
    CodigoSeguridad: 'Código de Seguridad',
    FechaVencimiento: 'Fecha de Vencimiento',
    Mes: 'Mes',
    Ano: 'Año',
    PrecioEnvioNacional: 'Precio envio nacional',
    EnvioGratis: 'Mi producto, incluye el envio el costo del envío al mundo entero.',
    ResumenCompra: 'Resumen de tu compra'
  },
  PayU: {
    MedioDePago: 'Medio de Pago',
    Credito: 'Tarjeta Crédito',
    Debito: 'Tarjeta Débito',
    Pse: 'Transferencia Bancaria (PSE)',
    Efectivo: 'Efectivo',
    Banco: 'Pago en Banco',
    InformacionDePago: 'Información de Pago',
    LlenarInfo: 'Completar Información con Datos de Envío',
    NombreCompleto: 'Nombre Completo',
    EmailAddress: 'Email',
    ContactPhone: 'Teléfono',
    TipoDeDocumento: 'Tipo De Documento',
    CC: 'Cédula de Ciudadanía',
    CE: 'Cédula de Extranjería',
    NIT: 'Número de Identificación Tributario',
    TI: 'Tarjeta de Identidad',
    PP: 'Pasaporte',
    IDC: 'Identificador Único de Cliente',
    CEL: 'Celular',
    RC: 'Registro Civil de Nacimiento',
    DE: 'Documento de Identificación Extranjero',
    NumeroDeDocumento: 'Número de Documento',
    Pais: 'País',
    Departamento: 'Departamento',
    Ciudad: 'Ciudad',
    Direccion: 'Dirección',
    CodigoPostal: 'Código Postal',
    NombreTarjeta: 'Nombre en la Tarjeta',
    NumeroTarjeta: 'Número de Tarjeta',
    CodigoSeguridad: 'Código de Seguridad',
    FechaVencimiento: 'Fecha de Vencimiento',
    FechaVencimientoHint: 'AAAA/MM'
  },
  Faq: {
    Compromisos: 'Compromisos de TrArtist'
  },
  Asesoria: {
    Titulo1: 'Artistas y Diseñadores Seleccionados',
    Descripcion1: 'Nuestros diseñadores y Artistas han pasado por un proceso de selección',
    Titulo2: 'Asesoría gratis',
    Descripcion2: 'Un curador o asesor te apoyará, si así deseas, a realizar una compra de acuerdo con tus necesidades.',
    Titulo3: 'Satisfacción en la compra',
    Descripcion3: 'Te garantizamos la devolución del dinero si el producto no corresponde al que te ofrecimos en www.trartist.com, o si tiene algún daño o defecto.',
    Titulo4: 'Curaduría o Asesoría',
    Descripcion4: 'En TrArtist sabemos que en muchas ocasiones queremos apoyo en una compra de una obra de arte o un objeto de diseño o en una prenda de diseño, ya sea por tener otra opinión u otra mirada a nuestra necesidad o por que simplemente no sabemos que opción elegir de tantas opciones posibles. La curaduría te ayudará a encontrar en TrArtist lo que deseas, también para servicios empresariales, arte, diseño o productos diseñados a la medida.',
    PreFormulario: 'Tenemos esta curaduría, asesoría gratuita, escríbenos contándonos tu necesidad y te apoyaremos lo mas pronto posible. Envíanos el siguiente formulario',
    Descripcion: 'Cuéntanos que asesoría necesitas?',
    SolicitarAsesoria: 'Solicitar Asesoría'
  },
  Envios: {
    Descripcion: 'Los productos adquiridos a través de TrArtist se enviarán a la dirección de entrega que nos indicaste y en los plazos estipulados.'
  },
  Administracion: {
    Letra: 'Letra',
    Fondo: 'Fondo',
    NuevaImagen: 'Nueva Imagen',
    Aprobar: 'Aprobar',
    Rechazar: 'Rechazar',
    Pendientes: 'Pendientes',
    Finalizados: 'Finalizados'
  },
  Regalo: {
    es: 'Español',
    Es: 'Español',
    en: 'Inglés',
    En: 'Inglés',
    Horario: 'Horario',
    NumeroPasajeros: 'Número de Pasajeros',
    Preferencias: 'Preferencias',
    ReservaTour: 'Reserva un Tour',
    FechaRequerido: 'Fecha Requerido',
    PasajerosRequerido: 'Número de Pasajeros Requerido',
    PreferenciasRequerido: 'Preferencias Requerido',
    HorarioRequerido: 'Horario Requerido',
    ValorRequerido: 'Valor Requerido',
    NombreRequerido: 'Nombre Requerido',
    CorreoRequerido: 'Correo Requerido',
    IdiomaRequerido: 'Idioma Requerido',
    CorreoRecibe: 'Correo de quien recibe',
    IdiomaRecibe: 'Idioma de quien recibe',
    Descripcion: 'Será una sorpresa maravillosa para quien reciba esta tarjeta regalo, tener la posibilidad de escoger un regalo único y muy especial, obras de arte o diseño.',
    Arma: 'Arma tu Regalo',
    Instrucciones: 'Selecciona un valor o personalízalo, escribe un mensaje, escoge la imagen que más te gusta y lo enviaremos por email inmediatamente.',
    OtraCantidad: 'Otra Cantidad',
    Mensaje: 'Escribe un mensaje para esa persona especial',
    De: 'De',
    Para: 'Para',
    Msj: 'Mensaje',
    Codigo: 'Código',
    Advertencia: '*El código mostrado es únicamente demostrativo y no será el código final de la tarjeta regalo',
    Cantidad: 'Valor'
  },
  Pagos: {
    Codigo: 'Código',
    Categoria: 'Categoria',
    Nombre: 'Nombre',
    Fecha: 'Fecha',
    Referencia: 'Referencia',
    ValorVenta: 'Valor de Venta',
    ValorPago: 'Valor de Pago',
    Comprobante: 'Comprobante',
    AdjuntarComprobante: 'Adjuntar Comprobante de Pago',
    ComprobantePago: 'SUBIR COMPROBANTE DE PAGO',
    SeleccionComprobante: '* Debe seleccionar un comprobante de pago para poder actualizar los datos'
  },
  Email: {
    TextoNewsletter: '<span>Hola {nombre},</span><br><br><span>Bienvenido a TrArtist, haz <a href="https://trartist.com/confirmarnewsletter/{uid}">Click Aquí</a> para confirmar tu suscripción</span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoVentas: 'Tu producto {titulo} ha sido enviado',
    TextoVentas: '<span>Hola {nombre}</span><br><br><span>Tu producto {titulo} ha sido enviado con el número de Guía {guia} a través de {transportadora}</span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoPagos: 'Tu producto {titulo} de referencia {uid} ha sido pago',
    TextoPagos: '<span>Hola {nombre}</span><br><br><span>Se ha realizado el pago del producto {titulo} de referencia {uid} puede verificarlo en su backOffice en su perfil de TrArtis, además se adjunta archivo pdf con comprobante de pago</span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoAprobado: 'Tu Aplicación en TrArtist ha Sido Aprobada',
    TextoAprobado: '<span>Hola {nombre},</span><br><br><span>Bienvenido a TrArtist, tu aplicación ha sido aceptada, ya puedes ingresar a TrArtist y registrarte como Artista o Diseñador con el código: {codigo}</span><br><br><span>1.Para que conozcas nuestras condiciones y cómo funcionamos , regístrate como artista o diseñador/a con el código que recibiste. Cuando accedas al backoffice, podrás conocer y acceder a toda la información relacionada a cómo funcionamos, cómo es la relación entre los vendedores (artistas y/o diseñadores) y TrArtist. En este punto no tienes ninguna obligación o contrato, no has aceptado nada, solo te da acceso a conocer nuestro funcionamiento. Si no estás de acuerdo con nuestros Términos o tienes dudas e inquietudes, puedes eliminar tu registro, no continuar con el proceso o puedes contactarnos a yoquiero@trartist.com o llamarnos  o escribirnos por whatsapp al +57 3213025754 Bogotá - Colombia. Con gusto te ayudaremos.</span><br><br><span>2. Revisa el primer punto de las capacitaciones allí puedes encontrar todo el proceso que debes seguir y  todos los detalles de nuestro funcionamiento. Esperamos que seas miembro de TrArtist y podamos construir juntos una comunidad maravillosa de crecimiento, innovación, creatividad y  hacer alianzas y negocios exitosos.</span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoRechazado: 'Tu Aplicación en TrArtist no ha sido exitosa',
    TextoRechazado: '<span>Hola {nombre},</span><br><br><span>Tu aplicación no ha sido exitosa.</span><br><br><span>{comentario}</span><br><br><span>Un saludo,</span><br><span><b>Equipo TrArtist</b></span><br><img src="https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FlogoFirma.png?alt=media&token=06daf706-dfb9-4c87-bc69-a8c9464dd0af"/>',
    AsuntoVentasProducto: 'Compra éxitosa',
    TextoVentasProducto: '<span>A continuación el resumen de su compra: </span><br>',
    Producto: 'Producto',
    CosteEnvio: 'Costo de Envio',
    TotalProducto: 'Precio',
    Cantidad: 'Cantidad',
    Tipo: 'Tipo'

  },
  Acceso: {
    TerminosYcondiciones: 'Ver Términos y Condiciones'
  },
  Correo: {
    Producto: 'Producto',
    CosteEnvio: 'Coste de envio',
    TotalProducto: 'Total producto',
    Cantidad: 'Cantidad',
    Tipo: 'Tipo',
    TotalPurchase: 'Compra Total',
    Date: 'Fecha'
  }
}
